var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "LinkedIn") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LinkedIn",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    transform: "translate(8, 8)",
    fill: "#8996A0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.95373665,9 L0.0320284698,9 L0.0320284698,2.57142857 L1.95373665,2.57142857 L1.95373665,9 Z M9,9 L7.07829181,9 L7.07829181,5.56585714 C7.07829181,4.671 6.7605694,4.2255 6.13088968,4.2255 C5.63188612,4.2255 5.31544484,4.47492857 5.15658363,4.97442857 C5.15658363,5.78571429 5.15658363,9 5.15658363,9 L3.23487544,9 C3.23487544,9 3.26049822,3.21428571 3.23487544,2.57142857 L4.75174377,2.57142857 L4.86896797,3.85714286 L4.90868327,3.85714286 C5.30263345,3.21428571 5.93231317,2.77842857 6.79580071,2.77842857 C7.45238434,2.77842857 7.98341637,2.96164286 8.3888968,3.42192857 C8.7969395,3.88285714 9,4.50128571 9,5.36978571 L9,9 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 0.992882562,
    cy: 0.964285714,
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-3",
    stroke: "#8996A0",
    strokeWidth: 0.625,
    cx: 12,
    cy: 12,
    r: 9.6875
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.b09d86d611f610c746ffeaea49a66f27.svg";
export { ForwardRef as ReactComponent };